module.exports = "<post-editor post=post form=form ng-if=form.id></post-editor> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/modify/main.html
// module id = 814
// module chunks = 0